export default "__VITE_ASSET__aeb143cc__"